import { render, staticRenderFns } from "./adjustList.vue?vue&type=template&id=6f54911f&"
import script from "./adjustList.vue?vue&type=script&lang=js&"
export * from "./adjustList.vue?vue&type=script&lang=js&"
import style0 from "./adjustList.vue?vue&type=style&index=0&id=6f54911f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports